
  <form @submit.prevent="save" ref="form">
    <b-loading :active="isLoading"></b-loading>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          <a
              :href="urlToOrderPdf"
              target="_blank"
              class="button is-small is-outlined is-pdf-link"
              v-if="currentOrder.id"
          >
            <i class="mdi">picture_as_pdf</i> PDF
          </a>
          <a
              :href="urlToOrderDoc"
              target="_blank"
              class="button is-small is-outlined is-doc-link"
              v-if="currentOrder.id && !isLite"
          >
            <i class="mdi">description</i> DOC
          </a>
          <span
              v-if="isMontageDateInfoVisible(currentOrder.montageDate)"
              :title="getMontageDateInfo(currentOrder.montageDate)"
              class="warning-icon"
          ><i class="mdi">warning</i></span
          >
          <span v-if="!currentOrder.id">Dodawanie zamówienia</span>
          <span v-else
          >{{ isEditModeEnabled ? 'Edycja' : 'Szczegóły' }} zamówienia: #{{
              currentOrder.id
            }}</span
          >
          <button
              type="button"
              class="button is-small is-info"
              v-if="currentOrder.baselinkerOrderId"
              style="margin-left: 10px;cursor: default;"
              @click="logBaselinkerOrderData"
          >
            Zamówienie z Baselinker
          </button>

          <button
              type="button"
              class="button is-small is-outlined to-route-button"
              @click="$parent.$emit('route-click', currentOrder.route)"
              v-if="currentOrder.route"
          >
            <i class="mdi">pageview</i>
            Trasa: {{ currentOrder.route.name }}
          </button>
        </p>
        <button
            type="button"
            class="delete"
            aria-label="close"
            @click="$parent.$emit('close')"
        ></button>
      </header>
      <section class="modal-card-body">
        <!-- <div class="dates">
          <p><span>Ostatnia edycja:</span> <b>{{ currentOrder.updatedDate|date('HH:mm DD.MM.YYYY') }}</b> przez <b>Jan Kowalski</b></p>
          <p><span>Dodano:</span> <b>{{ currentOrder.createdDate|date('HH:mm DD.MM.YYYY') }}</b> przez <b>Adam Nowacki</b></p>
        </div>-->
        <div class="columns">
          <div class="column">
            <h2>Klient</h2>
            <button
                v-if="!isLite"
                class="button is-small is-outlined"
                @click.prevent="copyClientDataToClipboard"
            >
              Do schowka
            </button>
            <div class="group">
              <div class="field is-horizontal">
                <div class="field-label">* Nazwa klienta:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.clientName"
                    required
                    placeholder="Imię Nazwisko / Nazwa firmy"
                    type="text"
                    @input="currentOrder.clientName = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">* Telefon:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.phone"
                    required
                    placeholder="600-123-123"
                    type="text"
                    @input="currentOrder.phone = $event"
                />
                <!-- <div class="field-body">
                  <span><i class="mdi">phone</i>{{ currentOrder.phone }}</span>
                  <span class="scnd-phone" v-show="currentOrder.scndPhone"><i class="mdi">phone</i>{{ currentOrder.scndPhone }}</span>
                </div>-->
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Drugi telefon:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.scndPhone"
                    placeholder="600-123-123"
                    type="text"
                    @input="currentOrder.scndPhone = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Email:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.email"
                    placeholder="jan.kowalski@email.com"
                    type="email"
                    @input="currentOrder.email = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Uwagi do kontaktu:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.contactNotes"
                    placeholder="Dzwonić po 18:00."
                    type="textarea"
                    @input="currentOrder.contactNotes = $event"
                />
              </div>
              <hr />
              <div class="field is-horizontal">
                <div class="field-label">* Kraj:</div>
                <b-field class="field-body" grouped>
                  <b-select
                      placeholder="Wybierz kraj"
                      v-model="currentOrder.country"
                      expanded
                      required
                      v-if="isEditModeEnabled"
                  >
                    <option value="PL">Polska</option>
                    <option value="CZ">Czechy</option>
                    <option value="SK">Słowacja</option>
                    <option value="RO">Rumunia</option>
                    <option value="HU">Węgry</option>
                    <option value="DE">Niemcy</option>
                    <option value="AT">Austria</option>
                    <option value="HR">Chorwacja</option>
                    <option value="SI">Słowenia</option>
                  </b-select>
                  <span
                      v-else
                      v-html="
											this.$options.filters.formatCountry(currentOrder.country) || 'nie wybrano'
										"
                  ></span>
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="isStateFieldEnabled">
                <div class="field-label">Województwo:</div>
                <b-field class="field-body" grouped v-if="currentOrder.country === 'PL'">
                  <b-select
                      placeholder="Wybierz województwo"
                      v-model="currentOrder.state"
                      expanded
                      v-if="isEditModeEnabled"
                  >
                    <option value="dolnośląskie">dolnośląskie</option>
                    <option value="kujawsko-pomorskie">kujawsko-pomorskie</option>
                    <option value="lubelskie">lubelskie</option>
                    <option value="lubuskie">lubuskie</option>
                    <option value="łódzkie">łódzkie</option>
                    <option value="małopolskie">małopolskie</option>
                    <option value="mazowieckie">mazowieckie</option>
                    <option value="opolskie">opolskie</option>
                    <option value="podkarpackie">podkarpackie</option>
                    <option value="podlaskie">podlaskie</option>
                    <option value="pomorskie">pomorskie</option>
                    <option value="śląskie">śląskie</option>
                    <option value="świętokrzyskie">świętokrzyskie</option>
                    <option value="warmińsko-mazurskie">warmińsko-mazurskie</option>
                    <option value="wielkopolskie">wielkopolskie</option>
                    <option value="zachodniopomorskie">zachodniopomorskie</option>
                  </b-select>
                  <span
                      v-else
                      v-html="
											this.$options.filters.formatCountry(currentOrder.state) || 'nie wybrano'
										"
                  ></span>
                </b-field>
                <b-field class="field-body" grouped v-else-if="currentOrder.country === 'HR'">
                  <b-select
                      placeholder="Wybierz żupanję"
                      v-model="currentOrder.state"
                      expanded
                      v-if="isEditModeEnabled"
                  >
                    <option value="zagrebačka">zagrebačka</option>
                    <option value="krapinsko-zagorska">krapinsko-zagorska</option>
                    <option value="sisačko-moslavačka">sisačko-moslavačka</option>
                    <option value="karlovačka">karlovačka</option>
                    <option value="varaždinska">varaždinska</option>
                    <option value="koprivničko-križevačka">koprivničko-križevačka</option>
                    <option value="bjelovarsko-bilogorska">bjelovarsko-bilogorska</option>
                    <option value="primorsko-goranska">primorsko-goranska</option>
                    <option value="ličko-senjska">ličko-senjska</option>
                    <option value="virovitičko-podravska">virovitičko-podravska</option>
                    <option value="požeško-slavonska">požeško-slavonska</option>
                    <option value="brodsko-posavska">brodsko-posavska</option>
                    <option value="zadarska">zadarska</option>
                    <option value="osječko-baranjska">osječko-baranjska</option>
                    <option value="šibensko-kninska">šibensko-kninska</option>
                    <option value="vukovarsko-srijemska">vukovarsko-srijemska</option>
                    <option value="splitsko-dalmatinska">splitsko-dalmatinska</option>
                    <option value="istarska">istarska</option>
                    <option value="dubrovačko-neretvanska">dubrovačko-neretvanska</option>
                    <option value="međimurska">međimurska</option>
                    <option value="grad zagreb">grad zagreb</option>
                  </b-select>
                  <span
                      v-else
                      v-html="
											this.$options.filters.formatCountry(currentOrder.state) || 'nie wybrano'
										"
                  ></span>
                </b-field>
                <editable
                    v-else
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.state"
                    placeholder="Województwo"
                    type="text"
                    @input="currentOrder.state = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Miasto:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.city"
                    placeholder="Kraków"
                    type="text"
                    @input="currentOrder.city = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Ulica:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.street"
                    placeholder="Szeroka 123"
                    type="text"
                    @input="currentOrder.street = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">* Kod pocztowy:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.postalCode"
                    required
                    placeholder="00-000"
                    type="text"
                    @input="currentOrder.postalCode = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">* Poczta:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.post"
                    required
                    placeholder="Poczta"
                    type="text"
                    @input="currentOrder.post = $event"
                />
              </div>
              <div class="field is-horizontal" v-if="currentOrder.id">
                <div class="field-label">Lokalizacja:</div>
                <div class="field field-body">
                  <button
                      type="button"
                      class="button is-info is-outlined"
                      :disabled="!canEdit"
                      @click.prevent="findLocation"
                      v-if="!isLocationFormVisible && !currentOrder.lat && !currentOrder.lon"
                  >
                    <i class="mdi">gps_fixed</i>
                    Znajdź
                  </button>
                  <b-dropdown
                      v-if="currentOrder.lat && currentOrder.lon && !isLocationFormVisible"
                      :disabled="!canEdit"
                  >
                    <button class="button is-info" slot="trigger" @click.prevent type="button">
											<span>
												GPS
												<small
                        >({{ currentOrder.lat | toFixed(3) }},
													{{ currentOrder.lon | toFixed(3) }})</small
                        >
											</span>
                      <i class="mdi">arrow_drop_down</i>
                    </button>
                    <b-dropdown-item @click="findLocation">
                      <i class="mdi">edit</i> Zmień
                    </b-dropdown-item>
                    <b-dropdown-item class="is-danger" @click="clearLocation">
                      <i class="mdi">cancel</i> Wyczyść
                    </b-dropdown-item>
                  </b-dropdown>
                  <div class="field is-expanded" v-if="isLocationFormVisible">
                    <b-field grouped>
                      <b-select
                          :placeholder="
													areLocationsLoading ? 'wczytywanie lokalizacji...' : 'Wybierz lokalizację'
												"
                          expanded
                          :loading="areLocationsLoading"
                          :disabled="areLocationsLoading"
                          @input="selectedLocation = $event"
                      >
                        <option
                            v-for="(location, index) in locations"
                            :key="index"
                            :value="{ lat: location.lat, lon: location.lon }"
                        >
                          {{ location.display_name }}
                          {{ location.isBestMatch ? ' [Najlepszy wynik]' : '' }}
                        </option>
                      </b-select>
                    </b-field>
                    <b-field grouped class="action-buttons">
                      <button
                          type="button"
                          class="button is-success"
                          @click.prevent="updateOrderLocation(selectedLocation)"
                          :disabled="!selectedLocation || areLocationsLoading"
                      >
                        <i class="mdi">add_location</i>
                        <span>Zapisz</span>
                      </button>
                      <button
                          type="button"
                          class="button"
                          @click.prevent="isLocationFormVisible = false"
                          :disabled="areLocationsLoading"
                      >
                        <i class="mdi">cancel</i>
                        <span>Anuuj</span>
                      </button>
                    </b-field>
                  </div>
                </div>
              </div>
              <hr />
              <div class="field is-horizontal">
                <div class="field-label">Pośrednik:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.broker"
                    required
                    :disabled="!isAdmin"
                    placeholder="Nazwa pośrednika"
                    type="text"
                    @input="currentOrder.broker = $event"
                />
              </div>
              <div class="field is-horizontal" v-if="isCommissionFieldVisible">
                <div class="field-label">
                  Prowizja (w {{ getCurrencyLabel(currentOrder.currency) }}):
                </div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.commission"
                    :currency="getCurrencyLabel(currentOrder.currency)"
                    placeholder="100"
                    type="currency"
                    @input="currentOrder.commission = $event"
                />
              </div>
              <div
                  class="calculate-commission-wrapper"
                  v-if="isCommissionFieldVisible && isCalculateCommissionEnabled"
              >
                <button
                    class="button is-small is-outlined"
                    @click.prevent="calculateCommission"
                    v-if="isEditModeEnabled"
                    :disabled="currentOrder.currency !== 'PLN'"
                >
                  Oblicz prowizję
                </button>
              </div>
              <hr />
              <div class="field is-horizontal">
                <div class="field-label">Faktura:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :checked="currentOrder.isInvoice"
                    @input="currentOrder.isInvoice = $event"
                    type="switch"
                />
              </div>
            </div>

            <div v-show="currentOrder.isInvoice">
              <h2>Dane na fakturze</h2>
              <button
                  class="button is-small is-outlined"
                  @click.prevent="copyClientAddress"
                  v-if="isEditModeEnabled"
              >
                Skopiuj z danych klienta
              </button>
              <div class="group">
                <div class="field is-horizontal">
                  <div class="field-label">* Nazwa firmy:</div>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.company"
                      placeholder="Firma ABC"
                      type="text"
                      :required="currentOrder.isInvoice"
                      @input="currentOrder.company = $event"
                  />
                </div>
                <div class="field is-horizontal">
                  <div class="field-label">* NIP:</div>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.nip"
                      placeholder="9999999999"
                      type="text"
                      :required="currentOrder.isInvoice"
                      @input="currentOrder.nip = $event"
                  />
                </div>
                <div class="field is-horizontal">
                  <div class="field-label">Czy firma jest płatnikiem VAT UE?:</div>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :checked="currentOrder.isVatUE"
                      @input="currentOrder.isVatUE = $event"
                      type="switch"
                  />
                </div>
                <div class="field is-horizontal">
                  <div class="field-label">Miasto:</div>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.invoiceCity"
                      placeholder="Miasto"
                      type="text"
                      @input="currentOrder.invoiceCity = $event"
                  />
                </div>
                <div class="field is-horizontal">
                  <div class="field-label">Ulica:</div>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.invoiceStreet"
                      placeholder="Szeroka 123"
                      type="text"
                      @input="currentOrder.invoiceStreet = $event"
                  />
                </div>
                <div class="field is-horizontal">
                  <div class="field-label">Kod pocztowy:</div>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.invoicePostalCode"
                      placeholder="00-000"
                      type="text"
                      @input="currentOrder.invoicePostalCode = $event"
                  />
                </div>
                <div class="field is-horizontal">
                  <div class="field-label">Poczta:</div>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.invoicePost"
                      placeholder="Poczta"
                      type="text"
                      @input="currentOrder.invoicePost = $event"
                  />
                </div>
                <div class="field is-horizontal" v-if="isStateFieldEnabled">
                  <div class="field-label">Województwo:</div>
                  <b-field class="field-body" grouped v-if="currentOrder.country === 'PL'">
                    <b-select
                        placeholder="Wybierz województwo"
                        v-model="currentOrder.invoiceState"
                        expanded
                        v-if="isEditModeEnabled"
                    >
                      <option value="dolnośląskie">dolnośląskie</option>
                      <option value="kujawsko-pomorskie">kujawsko-pomorskie</option>
                      <option value="lubelskie">lubelskie</option>
                      <option value="lubuskie">lubuskie</option>
                      <option value="łódzkie">łódzkie</option>
                      <option value="małopolskie">małopolskie</option>
                      <option value="mazowieckie">mazowieckie</option>
                      <option value="opolskie">opolskie</option>
                      <option value="podkarpackie">podkarpackie</option>
                      <option value="podlaskie">podlaskie</option>
                      <option value="pomorskie">pomorskie</option>
                      <option value="śląskie">śląskie</option>
                      <option value="świętokrzyskie">świętokrzyskie</option>
                      <option value="warmińsko-mazurskie">warmińsko-mazurskie</option>
                      <option value="wielkopolskie">wielkopolskie</option>
                      <option value="zachodniopomorskie">zachodniopomorskie</option>
                    </b-select>
                    <span
                        v-else
                        v-html="
												this.$options.filters.formatCountry(currentOrder.invoiceState) ||
												'nie wybrano'
											"
                    ></span>
                  </b-field>
                  <b-field class="field-body" grouped v-else-if="currentOrder.country === 'HR'">
                    <b-select
                        placeholder="Wybierz żupanję"
                        v-model="currentOrder.invoiceState"
                        expanded
                        v-if="isEditModeEnabled"
                    >
                      <option value="zagrebačka">zagrebačka</option>
                      <option value="krapinsko-zagorska">krapinsko-zagorska</option>
                      <option value="sisačko-moslavačka">sisačko-moslavačka</option>
                      <option value="karlovačka">karlovačka</option>
                      <option value="varaždinska">varaždinska</option>
                      <option value="koprivničko-križevačka">koprivničko-križevačka</option>
                      <option value="bjelovarsko-bilogorska">bjelovarsko-bilogorska</option>
                      <option value="primorsko-goranska">primorsko-goranska</option>
                      <option value="ličko-senjska">ličko-senjska</option>
                      <option value="virovitičko-podravska">virovitičko-podravska</option>
                      <option value="požeško-slavonska">požeško-slavonska</option>
                      <option value="brodsko-posavska">brodsko-posavska</option>
                      <option value="zadarska">zadarska</option>
                      <option value="osječko-baranjska">osječko-baranjska</option>
                      <option value="šibensko-kninska">šibensko-kninska</option>
                      <option value="vukovarsko-srijemska">vukovarsko-srijemska</option>
                      <option value="splitsko-dalmatinska">splitsko-dalmatinska</option>
                      <option value="istarska">istarska</option>
                      <option value="dubrovačko-neretvanska">dubrovačko-neretvanska</option>
                      <option value="međimurska">međimurska</option>
                      <option value="grad zagreb">grad zagreb</option>
                    </b-select>
                    <span
                        v-else
                        v-html="
												this.$options.filters.formatCountry(currentOrder.invoiceState) ||
												'nie wybrano'
											"
                    ></span>
                  </b-field>
                  <editable
                      v-else
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.invoiceState"
                      placeholder="Województwo"
                      type="text"
                      @input="currentOrder.invoiceState = $event"
                  />
                </div>
              </div>
            </div>

            <h2 v-show="!isEditModeEnabled">Historia</h2>
            <div class="group history" v-show="!isEditModeEnabled">
              <transition-group name="fade" tag="ul" class="list" mode="out-in">
                <li class="fade" v-for="log in getLogs()" :key="log.id">
                  <span class="action-icon" :data-action="log.action"></span>
                  <span class="editor"
                  >przez {{ log.creator ? log.creator.username : '-- brak danych --' }}</span
                  >
                  <span class="datetime">
										<small>{{ formatDate(log.createdDate, 'HH:mm') }}</small>
										{{ formatDate(log.createdDate, 'DD/MM/YYYY') }}
									</span>
                  <span class="action">- {{ formatLogAction(log) }}</span>
                </li>
              </transition-group>
              <a
                  class="show-full-history"
                  @click.prevent="isFullHistoryVisible = !isFullHistoryVisible"
                  v-if="currentOrder.logs && currentOrder.logs.length > 5"
              >
								<span v-if="isFullHistoryVisible">
									Pokaż mniej
									<i class="mdi">expand_less</i>
								</span>
                <span v-else>
									Pokaż całą historię
									<i class="mdi">expand_more</i>
								</span>
              </a>
            </div>
          </div>
          <div class="column">
            <h2>Szczegóły zamówienia</h2>
            <button
                v-if="!isLite"
                class="button is-small is-outlined"
                @click.prevent="copyOrderDataToClipboard"
            >
              Do schowka
            </button>
            <div class="group">
              <div class="field is-horizontal">
                <div class="field-label">Rodzaj produktu:</div>
                <b-field class="field-body" grouped>
                  <b-select
                      placeholder="Wybierz rodzaj produktu"
                      v-model="currentOrder.productType"
                      expanded
                      v-if="isEditModeEnabled"
                  >
                    <option value></option>
                    <option value="kojec">kojec</option>
                    <option value="garaż">garaż</option>
                    <option value="brama">brama</option>
                    <option value="hala">hala</option>
                    <option value="domek ogrodowy">domek ogrodowy</option>
                    <option value="projekt indywidualny">projekt indywidualny</option>
                    <option value="drewutnia">drewutnia</option>
                    <option value="garaż ocieplany">garaż ocieplany</option>
                  </b-select>
                  <span v-else v-html="currentOrder.productType || 'nie wybrano'"></span>
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="currentOrder.productType === 'brama'">
                <div class="field-label">Rodzaj bramy:</div>
                <b-field class="field-body" grouped>
                  <b-select
                      placeholder="Wybierz rodzaj bramy"
                      v-model="currentOrder.gateType"
                      expanded
                      v-if="isEditModeEnabled"
                  >
                    <option value></option>
                    <option value="dwuskrzydłowa">dwuskrzydłowa</option>
                    <option value="uchylna">uchylna</option>
                  </b-select>
                  <span v-else v-html="currentOrder.gateType || 'nie wybrano'"></span>
                </b-field>
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Liczba sztuk:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.numberOfPieces"
                    placeholder="1"
                    type="number"
                    @input="currentOrder.numberOfPieces = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Opis produktu:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.details"
                    placeholder="Pełny opis zamówienia."
                    type="textarea"
                    @input="currentOrder.details = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Dodatki:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.accessories"
                    placeholder="Dodatki do produktu."
                    type="textarea"
                    @input="currentOrder.accessories = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Link do produktu (1):</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.productLink"
                    placeholder="Link do produktu online."
                    type="url"
                    @input="currentOrder.productLink = $event"
                />
              </div>
              <div class="field is-horizontal" v-for="(link, index) in productsLinks" :key="index">
                <div class="field-label">Link do produktu ({{ index + 2 }}):</div>
                <div class="field field-body is-grouped" style="display: flex; flex-direction: row">
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="link"
                      placeholder="Link do produktu online."
                      type="url"
                      @input="productsLinks[index] = $event"
                  />
                  <button
                      type="button"
                      class="button"
                      v-if="isEditModeEnabled"
                      @click="productsLinks.splice(index, 1)"
                  >
                    <i class="mdi">delete</i>
                  </button>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label"></div>
                <button
                    type="button"
                    class="button is-info is-outlined"
                    :disabled="!canEdit"
                    v-if="isEditModeEnabled"
                    @click="
										Array.isArray(productsLinks)
											? (productsLinks = [...productsLinks, ''])
											: (productsLinks = [''])
									"
                >
                  <i class="mdi">add</i>
                  Dodaj kolejny produkt
                </button>
              </div>
              <div class="field attachment-section">
                <div class="field-label attachment-section__label">Załącznik:</div>
                <div
                    v-if="isMultipleOrderAttachmentsEnabled && currentOrder.id"
                    class="field-body picture-wrapper attachment-section__body"
                >
                  <div class="attachments-list">
                    <div
                        v-for="(att, idx) in attachmentListForMultiDisplay"
                        :key="att['@id'] || att.id || idx"
                        class="attachment-item"
                    >
                      <div class="attachment-item__preview">
                        <div
                            v-if="isAttachmentBeingDeleted(att, idx)"
                            class="attachment-item__preview-loading"
                        >
                          <b-loading :active="true" :is-full-page="false"></b-loading>
                        </div>
                        <div
                            v-if="!isAttachmentBeingDeleted(att) && isAttachmentMediaLoading(att, idx)"
                            class="attachment-item__preview-loading"
                        >
                          <b-loading :active="true" :is-full-page="false"></b-loading>
                        </div>
                        <vue-preview
                            v-else-if="!isAttachmentBeingDeleted(att) && att.media && att.media.imageDimensions"
                            :slides="slidesForAttachment(att)"
                            class="picture picture--small"
                        />
                        <a
                            v-else-if="!isAttachmentBeingDeleted(att) && att.media"
                            :href="attachmentDocUrl(att.media)"
                            target="_blank"
                            class="attachment-item__file"
                        >
                          <img
                              :src="`${path}/img/doc-bg.png`"
                              width="140"
                              height="105"
                              alt="Załącznik"
                              class="picture picture--small"
                          />
                        </a>
                      </div>
                      <div class="attachment-item__body">
                        <b-field v-if="canEdit" class="attachment-item__desc">
                          <b-input
                              v-model="att.description"
                              type="textarea"
                              rows="3"
                              placeholder="Opcjonalny opis"
                              :disabled="isAttachmentBeingDeleted(att)"
                              @input="markAttachmentDescriptionsDirty(att, idx)"
                          />
                        </b-field>
                        <p v-else-if="att.description" class="attachment-item__desc-read">{{ att.description }}</p>
                        <div v-if="canEdit" class="attachment-item__actions">
                          <button
                              type="button"
                              class="button is-info is-small"
                              :class="{ 'is-loading': isSavingAttachmentDescription(att, idx) }"
                              :disabled="isAttachmentBeingDeleted(att) || isUploading || isDeleting || isSavingAttachmentDescription(att, idx) || !isAttachmentDescriptionDirty(att, idx)"
                              @click="persistAttachmentDescriptions(att, idx)"
                          >
                            <i class="mdi">save</i>
                            <span>Zapisz</span>
                          </button>
                          <button
                              type="button"
                              class="button is-danger is-light is-small"
                              :class="{ 'is-loading': isAttachmentBeingDeleted(att) }"
                              :disabled="isAttachmentBeingDeleted(att) || isUploading || isDeleting || isSavingAttachmentDescription(att, idx) || !canEdit"
                              @click="removeAttachmentAt(idx)"
                          >
                            <i class="mdi">delete</i>
                            <span>{{ isAttachmentBeingDeleted(att) ? 'Usuwanie' : 'Usuń załącznik' }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                        v-if="canEdit && attachmentListForMulti.length < 4"
                        class="attachment-upload-tile"
                    >
                      <b-upload
                          v-model="file"
                          multiple
                          :accept="uploadAcceptAttribute"
                          @input="onMultiAttachmentFileInput"
                          :loading="isUploading"
                          :disabled="isDeleting || isUploading || !canEdit"
                          class="attachment-upload-tile__control"
                      >
                        <div
                            class="attachment-upload-tile__inner"
                            :class="{ 'is-loading': isUploading }"
                        >
                          <div v-if="isUploading" class="attachment-upload-tile__spinner">
                            <b-loading :active="true" :is-full-page="false"></b-loading>
                          </div>
                          <template v-else>
                            <span class="attachment-upload-tile__text">+ Dodaj</span>
                            <small>({{ attachmentListForMulti.length }}/4)</small>
                            <small class="attachment-upload-tile__hint">{{ uploadHintText }}</small>
                          </template>
                        </div>
                      </b-upload>
                    </div>
                  </div>
                </div>
                <div
                    v-else-if="!isMultipleOrderAttachmentsEnabled && currentOrder.id"
                    class="field-body picture-wrapper attachment-section__body"
                >
                  <!-- Deletion indicator -->
                  <div v-if="isDeleting" class="picture__deleting">
                    <b-loading :active="true" :is-full-page="false"></b-loading>
                  </div>
                  <!-- Image preview -->
                  <template v-else-if="singleAttachmentMedia">
                    <vue-preview
                        v-if="singleAttachmentMedia.imageDimensions"
                        :slides="slides"
                        class="picture"
                    />
                    <a
                        v-else
                        :href="docFile"
                        target="_blank"
                    >
                      <img
                          :src="`${path}/img/doc-bg.png`"
                          width="510"
                          height="383"
                          alt="Załącznik"
                          class="picture"
                      />
                      <p>{{ singleAttachmentMedia.filePath }}</p>
                    </a>
                  </template>
                  <b-field class="picture__buttons">
                    <b-upload
                        v-model="file"
                        :accept="uploadAcceptAttribute"
                        @input="onFileInputChange"
                        :loading="isUploading"
                        :disabled="isDeleting || !canEdit"
                    >
                      <a
                          class="button is-info"
                          :class="{ 'is-loading': isUploading }"
                          :disabled="isUploading || isDeleting || !canEdit"
                      >
                        <i class="mdi">cloud_upload</i>
                        <span>{{ singleAttachmentMedia ? 'Zmień' : 'Wybierz' }}</span>
                      </a>
                    </b-upload>
                    <button
                        type="button"
                        class="button is-danger"
                        :disabled="isUploading || isDeleting || !canEdit"
                        v-if="singleAttachmentMedia && !isDeleting && canEdit"
                        @click="deletePicture"
                    >
                      <i class="mdi">delete</i>
                      <span>Usuń załącznik</span>
                    </button>
                  </b-field>
                  <p v-if="canEdit" class="help attachment-section__hint">{{ uploadHintText }}</p>
                </div>
                <div v-else class="field-body attachment-section__body">
                  <p class="picture__empty">Załącznik będzie można dodać po zapisaniu zamówienia.</p>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label">
                  {{ orderPriceLabel }} (w {{ getCurrencyLabel(currentOrder.currency) }}):
                </div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.price"
                    :paymentVat="currentOrder.paymentVat"
                    :currency="getCurrencyLabel(currentOrder.currency)"
                    placeholder="2000"
                    type="currency"
                    @input="currentOrder.price = $event"
                />
              </div>
              <div
                  class="field is-horizontal"
                  v-if="hasSplitPayment(currentOrder.paymentMethod)"
              >
                <div class="field-label">
                  Zaliczka (w {{ getCurrencyLabel(currentOrder.currency) }}):
                </div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.advance"
                    :paymentVat="currentOrder.paymentVat"
                    :currency="getCurrencyLabel(currentOrder.currency)"
                    placeholder="500"
                    type="currency"
                    @input="currentOrder.advance = $event"
                />
              </div>
              <div
                  class="field is-horizontal"
                  v-if="hasSplitPayment(currentOrder.paymentMethod)"
              >
                <div class="field-label">Data wpłynięcia zaliczki:</div>
                <b-field class="field-body" grouped>
                  <flat-pickr
                      placeholder="Wybierz datę..."
                      v-model="advanceDateModel"
                      v-if="isEditModeEnabled"
                      :config="datePickerConfig"
                      class="input"
                  />
                  <span v-else>{{
                      normalizeMontageDate(currentOrder.advanceDate) || 'brak daty'
                    }}</span>
                </b-field>
              </div>
              <div class="field is-horizontal">
                <div class="field-label">
                  Cena dostawy (w {{ getCurrencyLabel(currentOrder.currency) }}):
                </div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.leftToPay"
                    :paymentVat="currentOrder.paymentVat"
                    :currency="getCurrencyLabel(currentOrder.currency)"
                    placeholder="500"
                    type="currency"
                    @input="currentOrder.leftToPay = $event"
                />
              </div>
              <div class="field is-horizontal" v-if="isPaidEnabled">
                <div class="field-label">Zapłacono:</div>
                <b-field class="field-body" grouped>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.paid"
                      :currency="getCurrencyLabel(currentOrder.currency)"
                      placeholder="1500"
                      type="currency"
                      @input="currentOrder.paid = $event"
                  />
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="isNettoBruttoEnabled">
                <div class="field-label">Netto/Brutto:</div>
                <b-field class="field-body" grouped>
                  <b-select
                      placeholder="Wybierz netto/brutto"
                      v-model="currentOrder.paymentVat"
                      expanded
                      v-if="isEditModeEnabled"
                  >
                    <option value="netto 0%">netto 0%</option>
                    <option value="brutto 19%">brutto 19%</option>
                    <option value="brutto 23%">brutto 23%</option>
                    <option value="brutto 27%">brutto 27%</option>
                  </b-select>
                  <span v-else v-html="currentOrder.paymentVat || 'nie wybrano'"></span>
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="!isEditModeEnabled">
                <div class="field-label">
                  SUMA (w {{ getCurrencyLabel(currentOrder.currency) }}):
                </div>
                <b-field class="field-body" grouped>
                  <span><b>{{ orderPriceSum | toFixed(2) }}</b></span>
                </b-field>
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Forma płatności:</div>
                <b-field class="field-body" grouped>
                  <b-select
                      placeholder="Wybierz formę płatności"
                      v-model="currentOrder.paymentMethod"
                      expanded
                      v-if="isEditModeEnabled"
                  >
                    <option value></option>
                    <option value="gotówka">gotówka</option>
                    <option value="przelew">przelew</option>
                    <option value="zaliczka + gotówka">zaliczka + gotówka</option>
                    <option value="zaliczka + przelew">zaliczka + przelew</option>
                    <option value="Payu + gotówka">Payu + gotówka</option>
                    <option value="Payu + przelew">Payu + przelew</option>
                    <option value="przedpłata">przedpłata</option>
                    <option value="płatność allegro">płatność allegro</option>
                    <option value="płatność Allegro Finance">płatność Allegro Finance</option>
                    <option value="płatność Payu">płatność Payu</option>
                    <option value="płatność Przelewy24">płatność Przelewy24</option>
                  </b-select>
                  <span v-else v-html="currentOrder.paymentMethod || 'nie wybrano'"></span>
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="isMultiCurrencyEnabled">
                <div class="field-label">* Waluta:</div>
                <b-field class="field-body" grouped>
                  <b-select
                      placeholder="Wybierz walutę"
                      v-model="currentOrder.currency"
                      expanded
                      required
                      v-if="isEditModeEnabled"
                  >
                    <option value="PLN">polski złoty</option>
                    <option value="CZK">korona czeska</option>
                    <option value="EUR">euro</option>
                    <option value="RON">lej rumuński</option>
                    <option value="HUF">forint</option>
                  </b-select>
                  <span v-else>
										<span v-if="currentOrder.currency === 'PLN'">polski złoty</span>
										<span v-if="currentOrder.currency === 'CZK'">korona czeska</span>
										<span v-if="currentOrder.currency === 'EUR'">euro</span>
										<span v-if="currentOrder.currency === 'RON'">lej rumuński</span>
										<span v-if="currentOrder.currency === 'HUF'">forint</span>
                    <!-- <svg
                      class="flag"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.0"
                      viewBox="0 0 30 20"
                      v-if="currentOrder.currency === 'PLN'"
                    >
                      <rect x="0" y="0" width="100%" height="50%" fill="#fff"></rect>
                      <rect x="0" y="50%" width="100%" height="50%" fill="#d7141a"></rect>
                    </svg>
                    <svg
                      class="flag"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.0"
                      viewBox="0 0 30 20"
                      v-if="currentOrder.currency === 'CZK'"
                    >
                      <rect x="0" y="0" width="100%" height="50%" fill="#fff"></rect>
                      <rect x="0" y="50%" width="100%" height="50%" fill="#d7141a"></rect>
                      <path d="M 15,10 0,0 V 20 z" fill="#11457e"></path>
                    </svg>-->
										({{ currentOrder.currency }})
									</span>
                </b-field>
              </div>
              <div class="field is-horizontal" v-show="!isEditModeEnabled">
                <div class="field-label">Status:</div>
                <div class="field-body">
                  <div class="tags has-addons">
                    <b-tag :type="getStatusCssClass(currentOrder.status)">{{
                        currentOrder.status | formatStatus
                      }}</b-tag>
                    <b-tag>{{ getLastStatusDate(currentOrder.logs) }}</b-tag>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal" v-if="currentOrder.id">
                <div class="field-label">Trasa:</div>
                <div class="field-body">
                  <div v-if="currentOrder.route">
                    <b-dropdown
                        :disabled="isNewRouteFormVisible || isChangeRouteFormVisible || !canEdit"
                    >
                      <button class="button is-info" slot="trigger" @click.prevent type="button">
                        <span>{{ currentOrder.route.name }}</span>
                        <i class="mdi">arrow_drop_down</i>
                      </button>
                      <b-dropdown-item @click="$parent.$emit('route-click', currentOrder.route)">
                        <i class="mdi">pageview</i> Podgląd trasy
                      </b-dropdown-item>
                      <b-dropdown-item @click="showChangeRouteForm">
                        <i class="mdi">edit</i> Zmień trasę
                      </b-dropdown-item>
                      <b-dropdown-item class="is-danger" @click="removeFromRoute">
                        <i class="mdi">cancel</i> Usuń z trasy
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <b-field v-if="!currentOrder.route">
                    <b-dropdown
                        :disabled="isNewRouteFormVisible || isChangeRouteFormVisible || !canEdit"
                    >
                      <button class="button is-info is-outlined" slot="trigger" @click.prevent>
                        <span>Przypisz</span>
                        <i class="mdi">arrow_drop_down</i>
                      </button>
                      <b-dropdown-item @click="showAddRouteForm">do nowej trasy</b-dropdown-item>
                      <b-dropdown-item @click="showChangeRouteForm"
                      >do obecnej trasy</b-dropdown-item
                      >
                    </b-dropdown>
                  </b-field>
                </div>
              </div>
              <div class="field is-horizontal" v-if="isNewRouteFormVisible">
                <div class="field-label">Nowa trasa:</div>
                <div class="field-body">
                  <div class="field is-expanded">
                    <b-field grouped>
                      <b-input
                          v-model="newRouteName"
                          placeholder="Nazwa nowej trasy"
                          expanded
                      ></b-input>
                    </b-field>
                    <b-field grouped class="action-buttons">
                      <button
                          type="button"
                          class="button is-success"
                          @click.prevent="addToNewRoute"
                          :disabled="!newRouteName"
                      >
                        <i class="mdi">add</i>
                        <span>Utwórz trasę</span>
                      </button>
                      <button type="button" class="button" @click.prevent="hideAddRouteForm">
                        <i class="mdi">cancel</i>
                        <span>Zamknij</span>
                      </button>
                    </b-field>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal" v-if="isChangeRouteFormVisible">
                <div class="field-label">Przypisanie do trasy:</div>
                <div class="field-body">
                  <div class="field is-expanded">
                    <b-field grouped>
                      <b-select
                          :placeholder="
													areActiveRoutesLoading ? 'wczytywanie tras...' : 'Wybierz trasę'
												"
                          expanded
                          :value="
													currentOrder.route ? getRouteIndexById(currentOrder.route.id) : null
												"
                          :loading="areActiveRoutesLoading"
                          :disabled="areActiveRoutesLoading"
                          @input="selectedRoute = activeRoutes[$event]"
                      >
                        <option v-for="(route, index) in activeRoutes" :value="index" :key="index">
                          {{ route.name }} ({{ routePointOrderCount(route) }})
                        </option>
                      </b-select>
                    </b-field>
                    <b-field grouped class="action-buttons">
                      <button
                          type="button"
                          class="button is-success"
                          @click.prevent="addToExisitingRoute"
                          :disabled="!selectedRoute || areActiveRoutesLoading"
                      >
                        <i class="mdi">add</i>
                        <span>Przypisz</span>
                      </button>
                      <button
                          type="button"
                          class="button"
                          @click.prevent="hideChangeRouteForm"
                          :disabled="areActiveRoutesLoading"
                      >
                        <i class="mdi">cancel</i>
                        <span>Anuuj</span>
                      </button>
                    </b-field>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal" v-if="!isLite">
                <div class="field-label">Montaż:</div>
                <b-field class="field-body" grouped>
                  <b-switch
                      v-model="currentOrder.isUrgent"
                      type="is-warning"
                      :disabled="isUpdatingSwitch"
                      :loading="isUpdatingSwitch"
                      @input="updateSwitchField"
                  >{{ currentOrder.isUrgent ? 'tak' : 'nie' }}</b-switch
                  >
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="isGroundPreparedEnabled">
                <div class="field-label">Teren przygotowany:</div>
                <b-field class="field-body" grouped>
                  <b-switch
                      v-model="currentOrder.isGroundPrepared"
                      type="is-success"
                      :disabled="isUpdatingSwitch"
                      :loading="isUpdatingSwitch"
                      @input="updateSwitchField"
                  >{{ currentOrder.isGroundPrepared ? 'tak' : 'nie' }}</b-switch
                  >
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="isConceptEnabled">
                <div class="field-label">Koncepcja:</div>
                <b-field class="field-body" grouped>
                  <b-switch
                      v-model="currentOrder.isConcept"
                      type="is-info"
                      :disabled="isUpdatingSwitch"
                      :loading="isUpdatingSwitch"
                      @input="updateSwitchField"
                  >{{ currentOrder.isConcept ? 'tak' : 'nie' }}</b-switch
                  >
                </b-field>
              </div>
              <hr v-if="isNotesEnabled" />
              <div class="field is-horizontal" v-if="isNotesEnabled">
                <div class="field-label">Uwagi:</div>
                <b-field class="field-body" grouped>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.notes"
                      placeholder="Uwagi do zamówienia"
                      type="textarea"
                      @input="currentOrder.notes = $event"
                  />
                </b-field>
              </div>
            </div>

            <h2>Montaż</h2>
            <div class="group montage">
              <div class="field is-horizontal">
                <div class="field-label">Uwagi do montażu:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentOrder.montageNotes"
                    placeholder="Uwagi dotyczące montażu."
                    type="textarea"
                    @input="currentOrder.montageNotes = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Data montażu:</div>
                <b-field class="field-body" grouped>
                  <flat-pickr
                      placeholder="Wybierz datę..."
                      v-model="montageDateModel"
                      v-if="isEditModeEnabled"
                      :config="datePickerConfig"
                      class="input"
                  />
                  <span v-else>{{ normalizeMontageDate(currentOrder.montageDate) }}</span>
                </b-field>
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Godzina montażu:</div>
                <b-field class="field-body" grouped>
                  <flat-pickr
                      placeholder="Wybierz godzinę..."
                      v-model="montageTimeModel"
                      v-if="isEditModeEnabled"
                      :config="timePickerConfig"
                      class="input"
                  />
                  <span v-else>{{ normalizeMontageTime(currentOrder.montageTime) }}</span>
                </b-field>
              </div>
              <hr v-if="isDistanceFromRoadEnabled || isGroundPreparationDateEnabled" />
              <div class="field is-horizontal" v-if="isDistanceFromRoadEnabled">
                <div class="field-label">Odległość od drogi:</div>
                <b-field class="field-body" grouped>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.distanceFromRoad"
                      placeholder="do 50m"
                      type="text"
                      @input="currentOrder.distanceFromRoad = $event"
                  />
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="isGroundPreparationDateEnabled">
                <div class="field-label">Data przygotowania podłoża:</div>
                <b-field class="field-body" grouped>
                  <editable
                      :isEditMode="isEditModeEnabled"
                      :value="currentOrder.groundPreparationDate"
                      placeholder="05.30.2025"
                      type="text"
                      @input="currentOrder.groundPreparationDate = $event"
                  />
                </b-field>
              </div>
              <hr v-if="isDistanceFromRoadEnabled || isGroundPreparationDateEnabled" />
              <div class="field is-horizontal" v-if="!isLite">
                <div class="field-label">Zatwierdzone:</div>
                <b-field class="field-body" grouped>
                  <b-switch
                      v-model="currentOrder.isApproved"
                      v-if="isEditModeEnabled"
                      type="is-warning"
                  >{{ currentOrder.isApproved ? 'tak' : 'nie' }}</b-switch
                  >
                  <span v-else>{{ currentOrder.isApproved ? 'tak' : 'nie' }}</span>
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="!isLite">
                <div class="field-label">FV wysłana:</div>
                <b-field class="field-body" grouped>
                  <b-switch
                      v-model="currentOrder.isInvoiceSent"
                      v-if="isEditModeEnabled"
                      type="is-info"
                  >{{ currentOrder.isInvoiceSent ? 'tak' : 'nie' }}</b-switch
                  >
                  <span v-else>{{ currentOrder.isInvoiceSent ? 'tak' : 'nie' }}</span>
                </b-field>
              </div>
              <div class="field is-horizontal" v-if="!isLite">
                <div class="field-label">FV zapłacona:</div>
                <b-field class="field-body" grouped>
                  <b-switch
                      v-model="currentOrder.isInvoicePaid"
                      v-if="isEditModeEnabled"
                      type="is-danger"
                  >{{ currentOrder.isInvoicePaid ? 'tak' : 'nie' }}</b-switch
                  >
                  <span v-else>{{ currentOrder.isInvoicePaid ? 'tak' : 'nie' }}</span>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="level">
          <div class="level-left">
            <button type="submit" class="button is-success button--save" v-if="isEditModeEnabled">
              <i class="mdi">save</i> Zapisz zmiany
            </button>
            <button
                class="button is-primary button--edit"
                :disabled="!canEdit"
                @click.prevent="isEditModeEnabled = true"
                v-else
            >
              <i class="mdi">edit</i> Edytuj
            </button>
            <!-- <button
              class="button is-info"
              @click.prevent="$parent.$emit('route-click', currentOrder.route)"
              v-if="currentOrder.route"
            >Trasa</button>-->
            <button class="button is-white button--cancel" @click.prevent="$parent.$emit('close')">
              Zamknij
            </button>
            <p v-if="!isAdmin && !agentsCanEditEverything && secondsLeftToEdit > 0">
              Pozostało Ci {{ Math.floor(secondsLeftToEdit / 60) }} minut
              {{ secondsLeftToEdit - Math.floor(secondsLeftToEdit / 60) * 60 }} sekund na edycję.
            </p>
          </div>
          <div class="level-right">
            <button
                class="button is-info"
                @click.prevent="accept"
                v-if="currentOrder.status === 'pending'"
            >
              Akceptuj
            </button>
            <b-dropdown position="is-top-left">
              <button class="button" slot="trigger" @click.prevent type="button">
                <span>Więcej</span>
                <i class="mdi">arrow_drop_down</i>
              </button>
              <b-dropdown-item
                  v-if="currentOrder.status !== 'archived'"
                  @click="archive"
                  :disabled="!canEdit"
              >
                <i class="mdi">archive</i> Archiwizuj
              </b-dropdown-item>
              <b-dropdown-item
                  @click="accept"
                  v-if="currentOrder.status === 'pending'"
                  :disabled="!canEdit"
              >
                <i class="mdi">check</i> Akceptuj
              </b-dropdown-item>
              <b-dropdown-item
                  v-if="currentOrder.status !== 'complaint' && config.canMoveToComplaints"
                  :disabled="!canEdit"
                  @click="moveToComplaint"
              >
                <i class="mdi">refresh</i> {{ config.orderStatusNames.complaint.charAt(0).toUpperCase() + config.orderStatusNames.complaint.slice(1).toLowerCase() }}
              </b-dropdown-item>
              <b-dropdown-item
                  v-if="currentOrder.status !== 'trashed' && config.canMoveToTrash"
                  :disabled="!canEdit"
                  @click="moveToTrash"
              >
                <i class="mdi">delete_forever</i> Do kosza
              </b-dropdown-item>
              <b-dropdown-item :disabled="!canEdit" @click="showDeleteDialog">
                <i class="mdi">cancel</i> Usuń permanentnie
              </b-dropdown-item>
              <b-dropdown-item
                  v-if="canDuplicateOrder"
                  :disabled="!canEdit"
                  @click="showDuplicateDialog"
              >
                <i class="mdi">content_copy</i> Duplikuj
              </b-dropdown-item>
              <b-dropdown-item
                  class="is-danger"
                  @click="$parent.$emit('route-click', currentOrder.route)"
                  :disabled="!currentOrder.route"
              >
                <i class="mdi">pageview</i> Trasa
              </b-dropdown-item>
              <hr
                  class="dropdown-divider"
                  v-if="
									currentOrder.status === 'planned' ||
									currentOrder.status === 'archived' ||
									currentOrder.status === 'trashed' ||
									currentOrder.status === 'complaint'
								"
              />
              <b-dropdown-item
                  class="is-danger"
                  :disabled="!canEdit"
                  v-if="
									currentOrder.status === 'planned' ||
									currentOrder.status === 'sent' ||
									currentOrder.status === 'archived' ||
									currentOrder.status === 'trashed' ||
									currentOrder.status === 'complaint'
								"
                  @click="unarchiveToPending"
              >
                <i class="mdi">archive</i> Przenieś do oczekujących
              </b-dropdown-item>
              <b-dropdown-item
                  class="is-danger"
                  :disabled="!canEdit"
                  v-if="
									currentOrder.status === 'planned' ||
									currentOrder.status === 'sent' ||
									currentOrder.status === 'archived' ||
									currentOrder.status === 'trashed' ||
									currentOrder.status === 'complaint'
								"
                  @click="unarchiveToNew"
              >
                <i class="mdi">archive</i> Przenieś do nowych
              </b-dropdown-item>
            </b-dropdown>
            <!--
            <button
              class="button is-danger is-small button--delete"
              @click.prevent="showDeleteDialog"
            >Usuń</button>-->
          </div>
        </div>
      </footer>
    </div>
  </form>
